/**
 * Mobile Quick Add Bottom Sheet
 * Modal estilo iOS para seleção de variantes no mobile
 */

(function () {
  'use strict';

  var modal = document.getElementById('mobile-quick-add-modal');
  var contentEl = document.getElementById('mobile-quick-add-content');
  var imageWrapper = document.getElementById('mobile-quick-add-image-wrapper');
  var imageEl = document.getElementById('mobile-quick-add-image');
  var currentProduct = null;
  var currentSelections = [];
  var currentCard = null;
  var currentColorMap = {};
  var currentColorVariants = null; // dados do metafield color_variants
  var modalCurrentHandle = ''; // handle do produto atual dentro do modal

  function isDesktopCartDrawerOpen() {
    var cartDrawer = document.getElementById('cart-drawer');
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 1024px)').matches;
    return isDesktop && cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false';
  }

  function setCartDrawerQuickAddWidth() {
    var cartDrawerContent = document.getElementById('cart-drawer-content');
    var width = cartDrawerContent ? cartDrawerContent.getBoundingClientRect().width : 0;
    document.body.style.setProperty('--cart-drawer-quick-add-width', (width || 448) + 'px');
  }

  window.openMobileQuickAdd = function (productJson, cardElement) {
    if (!modal || !contentEl || !productJson) {
      return;
    }
    currentProduct = productJson;
    currentCard = cardElement;
    currentColorMap = {};
    currentColorVariants = null;

    // Lê o mapa de cores e os color_variants do card se existirem
    if (cardElement) {
      if (cardElement.dataset.colorMap) {
        var mapStr = cardElement.dataset.colorMap;
        var pairs = mapStr.split(',');
        for (var p = 0; p < pairs.length; p++) {
          var pair = pairs[p];
          var sep = pair.indexOf(':');
          if (sep !== -1) {
            var key = pair.substring(0, sep).trim();
            var val = pair.substring(sep + 1).trim();
            currentColorMap[key] = val;
          }
        }
      }
      if (cardElement.dataset.colorVariants) {
        try {
          currentColorVariants = JSON.parse(cardElement.dataset.colorVariants);
        } catch (e) {
          currentColorVariants = null;
        }
      }
    }

    // Normaliza o produto para garantir formato consistente
    normalizeProduct(currentProduct);

    // Garante que options seja sempre um array de objetos {name, values}
    if (currentProduct.options && currentProduct.options.length > 0 && typeof currentProduct.options[0] === 'string') {
      var stringOpts = currentProduct.options;
      currentProduct.options = [];
      for (var sIdx = 0; sIdx < stringOpts.length; sIdx++) {
        var sValues = [];
        var sSeen = {};
        if (currentProduct.variants) {
          for (var sv = 0; sv < currentProduct.variants.length; sv++) {
            var sV = currentProduct.variants[sv];
            var sVal = sV.options ? sV.options[sIdx] : (sV['option' + (sIdx + 1)]);
            if (sVal && !sSeen[sVal]) {
              sSeen[sVal] = true;
              sValues.push(sVal);
            }
          }
        }
        currentProduct.options.push({ name: stringOpts[sIdx], position: sIdx + 1, values: sValues });
      }
    }

    currentSelections = new Array(currentProduct.options.length).fill(null);

    // Pré-seleciona a cor baseada no produto atual do card
    var colorIdx = getColorOptionIndex(currentProduct);
    if (colorIdx >= 0 && currentProduct.variants && currentProduct.variants.length > 0) {
      var firstV = currentProduct.variants[0];
      var preColor = firstV.options ? firstV.options[colorIdx] : (firstV['option' + (colorIdx + 1)]);
      if (preColor) {
        currentSelections[colorIdx] = preColor;
      }
    }

    modalCurrentHandle = currentProduct.handle || '';

    var openedInCartDrawer = isDesktopCartDrawerOpen();
    if (openedInCartDrawer) {
      setCartDrawerQuickAddWidth();
    } else {
      document.body.style.removeProperty('--cart-drawer-quick-add-width');
    }

    renderModalContent(currentProduct);
    modal.classList.remove('hidden');
    modal.classList.toggle('cart-drawer-quick-add-modal', openedInCartDrawer);
    document.body.style.overflow = 'hidden';
    document.body.classList.toggle('cart-drawer-quick-add-open', openedInCartDrawer);
    // Pequeno delay para garantir que o navegador processe a remoção do display:none
    // antes de iniciar as transições CSS
    requestAnimationFrame(function () {
      document.body.classList.add('mobile-quick-add-open');
    });
  };

  window.closeMobileQuickAdd = function () {
    if (!modal) return;
    var wasCartDrawerQuickAdd = modal.classList.contains('cart-drawer-quick-add-modal');
    document.body.classList.remove('mobile-quick-add-open');
    if (!wasCartDrawerQuickAdd) {
      document.body.classList.remove('cart-drawer-quick-add-open');
      document.body.style.removeProperty('--cart-drawer-quick-add-width');
    }
    // Pequeno delay para permitir a animação de saída antes de esconder
    setTimeout(function () {
      modal.classList.add('hidden');
      modal.classList.remove('cart-drawer-quick-add-modal');
      document.body.classList.remove('cart-drawer-quick-add-open');
      document.body.style.removeProperty('--cart-drawer-quick-add-width');
      var cartDrawer = document.getElementById('cart-drawer');
      var cartDrawerOpen = cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false';
      document.body.style.overflow = cartDrawerOpen ? 'hidden' : '';
      currentProduct = null;
      currentSelections = [];
      currentCard = null;
      currentColorVariants = null;
    }, 400);
  };

  function normalizeProduct(product) {
    // Normaliza variantes: converte option1, option2, option3 para array options
    if (product.variants) {
      for (var vi = 0; vi < product.variants.length; vi++) {
        var v = product.variants[vi];
        if (!v.options || !v.options.length) {
          v.options = [];
          if (v.option1) v.options.push(v.option1);
          if (v.option2) v.options.push(v.option2);
          if (v.option3) v.options.push(v.option3);
        }
      }
    }

    // Se não tiver options, tenta construir a partir das variantes
    if (!product.options || !product.options.length) {
      if (product.variants && product.variants.length > 0) {
        var firstVariant = product.variants[0];
        if (firstVariant.options && firstVariant.options.length) {
          product.options = [];
          for (var i = 0; i < firstVariant.options.length; i++) {
            var optName = (product.options_with_values && product.options_with_values[i])
              ? product.options_with_values[i].name
              : ('Opção ' + (i + 1));
            var optValues = [];
            for (var v = 0; v < product.variants.length; v++) {
              var val = product.variants[v].options[i];
              if (val && optValues.indexOf(val) === -1) {
                optValues.push(val);
              }
            }
            product.options.push({ name: optName, position: i + 1, values: optValues });
          }
        }
      }
    }

    // Se options for array de strings (formato antigo do Liquid), converte
    if (product.options && product.options.length > 0 && typeof product.options[0] === 'string') {
      var stringOptions = product.options;
      product.options = [];
      for (var idx = 0; idx < stringOptions.length; idx++) {
        var values = [];
        if (product.variants) {
          for (var vj = 0; vj < product.variants.length; vj++) {
            var vval = product.variants[vj].options[idx];
            if (vval && values.indexOf(vval) === -1) values.push(vval);
          }
        }
        product.options.push({ name: stringOptions[idx], position: idx + 1, values: values });
      }
    }
  }

  function getColorOptionIndex(product) {
    if (!product || !product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = ((product.options[i].name || '') + '').toLowerCase();
      if (name.indexOf('cor') !== -1 || name.indexOf('color') !== -1) {
        return i;
      }
    }
    return -1;
  }

  function findVariant(product, selections) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < selections.length; j++) {
        if (selections[j] !== null && v.options[j] !== selections[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function optionValueAvailable(product, optionIndex, value) {
    if (!product || !product.variants) return true;

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (!variant.available || !variant.options || variant.options[optionIndex] !== value) continue;

      var matchesSelectedOptions = true;
      for (var j = 0; j < currentSelections.length; j++) {
        if (j === optionIndex || currentSelections[j] === null) continue;
        if (variant.options[j] !== currentSelections[j]) {
          matchesSelectedOptions = false;
          break;
        }
      }

      if (matchesSelectedOptions) return true;
    }

    return false;
  }

  function selectedVariantAvailable(product) {
    var allSelected = currentSelections.every(function (s) { return s !== null; });
    if (!allSelected) return false;

    var variant = findVariant(product, currentSelections);
    return !!(variant && variant.available);
  }

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return 'R$ ' + value;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function renderModalContent(product) {
    var colorIdx = getColorOptionIndex(product);
    var firstVariant = product.variants && product.variants[0];
    var imageUrl = product.images && product.images.length > 0 ? product.images[0] : '';
    var price = firstVariant ? firstVariant.price : 0;
    var comparePrice = firstVariant ? firstVariant.compare_at_price : 0;

    // --- Imagem (renderizada no wrapper separado, fora do content) ---
    if (imageEl) {
      if (imageUrl) {
        imageEl.src = imageUrl;
        imageEl.alt = product.title || '';
        imageWrapper.style.display = '';
      } else {
        imageWrapper.style.display = 'none';
      }
    }

    var html = '';

    // Título
    html += '<h2 class="mqa-title">' + escapeHtml(product.title) + '</h2>';

    // Preço
    html += '<div class="mqa-price">' + formatMoney(price);
    if (comparePrice && comparePrice > price) {
      html += ' <span style="text-decoration:line-through;opacity:0.5;font-weight:400;margin-left:0.5rem;">' + formatMoney(comparePrice) + '</span>';
    }
    html += '</div>';

    // --- Opções de variante ---
    if (product.options && product.options.length > 0) {
      for (var optIdx = 0; optIdx < product.options.length; optIdx++) {
        var option = product.options[optIdx];
        if (!option || !option.values || option.values.length === 0) continue;

        var isColor = optIdx === colorIdx;

        // Se for cor e temos color_variants do metafield, renderiza a partir deles
        if (isColor && currentColorVariants && currentColorVariants.length > 0) {
          html += renderColorVariantsSection(product, optIdx);
          continue;
        }

        html += '<div class="mqa-section">';
        html += '<span class="mqa-label">' + escapeHtml(option.name) + '</span>';
        html += '<div class="mqa-options">';

        for (var v = 0; v < option.values.length; v++) {
          var val = option.values[v];
          var isSelected = currentSelections[optIdx] === val;
          var isAvailable = optionValueAvailable(product, optIdx, val);
          var btnClass = isColor ? 'mqa-swatch' : 'mqa-option';
          var activeClass = isSelected ? ' is-active' : '';
          var unavailableClass = isAvailable ? '' : ' is-unavailable';
          var disabledAttrs = isAvailable ? '' : ' disabled aria-disabled="true"';

          if (isColor) {
            var bg = currentColorMap[val] || val.toLowerCase();
            var isImage = bg.indexOf('http') === 0 || bg.indexOf('//') === 0;
            if (isImage) {
              html += '<button type="button" class="' + btnClass + activeClass + unavailableClass + '" data-opt-index="' + optIdx + '" data-value="' + escapeHtml(val) + '" style="background-image:url(' + escapeHtml(bg) + ');background-size:cover;" title="' + escapeHtml(val) + '"' + disabledAttrs + '></button>';
            } else {
              html += '<button type="button" class="' + btnClass + activeClass + unavailableClass + '" data-opt-index="' + optIdx + '" data-value="' + escapeHtml(val) + '" style="background-color:' + escapeHtml(bg) + ';" title="' + escapeHtml(val) + '"' + disabledAttrs + '></button>';
            }
          } else {
            html += '<button type="button" class="' + btnClass + activeClass + unavailableClass + '" data-opt-index="' + optIdx + '" data-value="' + escapeHtml(val) + '"' + disabledAttrs + '>' + escapeHtml(val) + '</button>';
          }
        }

        html += '</div></div>';
      }
    }

    // Botão adicionar
    var canAdd = selectedVariantAvailable(product);
    html += '<button type="button" class="mqa-add-btn" data-mqa-add ' + (canAdd ? '' : 'disabled') + '>Adicionar à sacola</button>';

    contentEl.innerHTML = html;
    bindModalEvents();
  }

  /**
   * Renderiza a seção de cor usando os dados do metafield color_variants
   * em vez dos valores das variantes do produto atual.
   */
  function renderColorVariantsSection(product, colorOptIdx) {
    if (!currentColorVariants || !currentColorVariants.length) return '';

    var html = '<div class="mqa-section">';
    html += '<span class="mqa-label">Cor</span>';
    html += '<div class="mqa-options">';

    for (var i = 0; i < currentColorVariants.length; i++) {
      var cv = currentColorVariants[i];
      var colorName = cv.color || '';
      var swatch = cv.swatch || '';
      var handle = cv.handle || '';
      var isAvailable = cv.available !== false;

      // Verifica se esta cor é a do produto atual (pré-selecionada)
      var productHandle = product.handle || (currentCard && currentCard.dataset.productHandle) || '';
      var isCurrentProduct = handle === productHandle;
      var isSelected = isCurrentProduct;
      var activeClass = isSelected ? ' is-active' : '';
      var unavailableClass = isAvailable ? '' : ' is-unavailable';
      var disabledAttrs = isAvailable ? '' : ' disabled aria-disabled="true"';

      var isImage = swatch.indexOf('http') === 0 || swatch.indexOf('//') === 0;

      if (isImage) {
        html += '<button type="button" class="mqa-swatch' + activeClass + unavailableClass + '"' +
          ' data-color-nav="' + escapeHtml(handle) + '"' +
          ' data-opt-index="' + colorOptIdx + '"' +
          ' data-value="' + escapeHtml(colorName) + '"' +
          ' style="background-image:url(' + escapeHtml(swatch) + ');background-size:cover;"' +
          ' title="' + escapeHtml(colorName) + '"' + disabledAttrs + '></button>';
      } else {
        html += '<button type="button" class="mqa-swatch' + activeClass + unavailableClass + '"' +
          ' data-color-nav="' + escapeHtml(handle) + '"' +
          ' data-opt-index="' + colorOptIdx + '"' +
          ' data-value="' + escapeHtml(colorName) + '"' +
          ' style="background-color:' + escapeHtml(swatch) + ';"' +
          ' title="' + escapeHtml(colorName) + '"' + disabledAttrs + '></button>';
      }
    }

    html += '</div></div>';
    return html;
  }

  /**
   * Carrega um novo produto via AJAX (/products/HANDLE.js) e atualiza o modal.
   */
  function loadProductByHandle(handle, clickedBtn) {
    if (!handle) return;

    // Mostra estado de loading no botão clicado
    if (clickedBtn) clickedBtn.classList.add('is-loading');

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Erro ao carregar produto');
        return res.json();
      })
      .then(function (newProduct) {
        // Normaliza o novo produto
        normalizeProduct(newProduct);

        // Atualiza o produto atual
        currentProduct = newProduct;

        // Reset selections e pré-seleciona a cor baseada na nova variante
        currentSelections = new Array(currentProduct.options.length).fill(null);
        var newColorIdx = getColorOptionIndex(currentProduct);
        if (newColorIdx >= 0 && currentProduct.variants && currentProduct.variants.length > 0) {
          currentSelections[newColorIdx] = currentProduct.variants[0].options[newColorIdx];
        }

        // Atualiza o card reference para o novo handle (opcional, mantém o mesmo card
        // pois o color_variants é o mesmo grupo, mas atualiza o handle para comparações futuras)
        if (currentCard) {
          currentCard.dataset.productHandle = handle;
        }

        // Re-renderiza o modal
        renderModalContent(currentProduct);
      })
      .catch(function () {
        // Em caso de erro, navega para a página do produto como fallback
        window.location.href = '/products/' + handle;
      })
      .finally(function () {
        if (clickedBtn) clickedBtn.classList.remove('is-loading');
      });
  }

  function bindModalEvents() {
    if (!contentEl) return;

    // Clique nas opções
    contentEl.querySelectorAll('[data-opt-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-unavailable')) return;

        var optIdx = parseInt(btn.dataset.optIndex, 10);
        var val = btn.dataset.value;
        var colorNav = btn.dataset.colorNav;

        // Se for um swatch de cor vindo de color_variants e clicou em outro produto
        var currentHandle = currentProduct.handle || modalCurrentHandle || '';
        if (colorNav && colorNav !== currentHandle) {
          // Carrega o novo produto via AJAX e atualiza o modal
          loadProductByHandle(colorNav, btn);
          return;
        }

        // Remove seleção dos irmãos
        var group = btn.parentElement;
        group.querySelectorAll('[data-opt-index]').forEach(function (b) {
          b.classList.remove('is-active');
        });

        // Adiciona seleção
        currentSelections[optIdx] = val;

        renderModalContent(currentProduct);
      });
    });

    // Botão adicionar à sacola
    var addBtn = contentEl.querySelector('[data-mqa-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;

        var variant = findVariant(currentProduct, currentSelections);
        if (!variant || !variant.available) {
          addBtn.textContent = 'Indisponível';
          setTimeout(function () { addBtn.textContent = 'Adicionar à sacola'; }, 1500);
          return;
        }

        addBtn.textContent = 'Adicionando...';
        addBtn.disabled = true;
        addBtn.style.background = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Erro');
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Adicionado à sacola!';
            addBtn.style.background = '';
            if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
            setTimeout(function () {
              window.closeMobileQuickAdd();
            }, 800);
          })
          .catch(function () {
            addBtn.textContent = 'Erro ao adicionar';
            addBtn.style.background = '';
            setTimeout(function () { addBtn.textContent = 'Adicionar à sacola'; addBtn.disabled = false; }, 1500);
          });
      });
    }
  }

  // Fecha ao clicar no backdrop
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('mobile-quick-add-backdrop')) {
        window.closeMobileQuickAdd();
      }
    });
  }

  // Fecha com Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) {
      window.closeMobileQuickAdd();
    }
  });
})();
